module.exports = __webpack_public_path__ + "static/media/5_Company lobby-LiFORK Lab - Japan.978bdab8.jpg";